define('views/modules/member/member/edit/member-edit-panel',[
    // Libs
    'underscore', 'utils',
    // collections
    'collections/member/groups',
    //events
    'services/events/user-events',
    // views
    'views/parts/panel/base-panel',
    'views/modules/member/member/edit/member-edit-content',
], function(
    // Libs
    _, U,
    // collections
    CGroups,
    //events
    UserEvents,
    // views
    VBasePanel,
    VMemberEditContent
) {

    var VMemberEditPanel = VBasePanel.extend({
        header: {
          title: "supervisor:member-edit-title",
          subtitle: "supervisor:member-edit-subtitle",
        },
        buttons: { back: 'close', },
        content: { edit: VMemberEditContent, },
        tabs: [{ id: 'edit', active: true }],

        initialize: function(opt) {
            this.selectedGroup = opt.selectedGroup;
            this.memberList = opt.memberList;
            this.collection = new CGroups(null, { tree: true, tree_only: true, removeExpired: true });
        },

        render: function() {
            VMemberEditPanel.__super__.render.apply(this, arguments);
            this.collection.fetch();

            this.showEdit();

            if (this.view.edit)
            {
              this.view.edit.selectedGroup = this.selectedGroup;
              this.listenTo(this.view.edit, 'member:edit', this.onMemberEdit);
            }

            return this;
        },

        getContentViewOptions: function(options) {
            return _.extend({}, options, {
              model: this.model,
              collection: this.collection,
              selectedGroup: this.selectedGroup,
            });
        },

        showEdit: function() { return this.showContent('edit'); },

        onClosePanel: function() {
            var view = this.view;
            view.edit.setPristine();
            UserEvents.closingEditSettingPanel();
        },

        onMemberEdit: function(model) {
          if (this.memberList) {
              this.memberList.addMember(model);
          }
        }

    });

    return VMemberEditPanel;
});

